import { textUpperFirst } from '../../../text/upperFirst';
import { offerSearchTextDealType } from './dealType';
import { offerSearchTextCategoryType } from './categoryType';
import { offerSearchTextRoomType } from './roomType';
import { offerSearchTextRenovation } from './renovation';
import { offerSearchTextMetro } from './metro';
import { offerSearchTextDistrict } from './district';
import { offerSearchSeoIconCategory } from './seoIconCategory';

export class OfferSearchTextBuilder {
    constructor() {}

    dealAndCategory(params:
        Parameters<typeof offerSearchTextDealType>[0]
        & Parameters<typeof offerSearchTextCategoryType>[0]
        & { regionText?: string }
    ) {
        return textUpperFirst(`${offerSearchTextDealType(params)} ${offerSearchTextCategoryType(params)} ${params.regionText}`);
    }

    roomType(params: Parameters<typeof offerSearchTextRoomType>[0]) {
        return offerSearchTextRoomType(params);
    }

    renovation(params: Parameters<typeof offerSearchTextRenovation>[0]) {
        return offerSearchTextRenovation(params);
    }

    metro(params: Parameters<typeof offerSearchTextMetro>[0]) {
        return offerSearchTextMetro(params);
    }

    district(params: Parameters<typeof offerSearchTextDistrict>[0]) {
        return offerSearchTextDistrict(params);
    }

    seoIconCategory(params: Parameters<typeof offerSearchSeoIconCategory>[0]) {
        const seoIcon = offerSearchSeoIconCategory(params);

        return seoIcon ? `${seoIcon} ` : '';
    }
}
